export default "__VITE_PUBLIC_ASSET__c193e799__"